import { CalendarCheck } from "lucide-react";

export default function FinalCTA({ onBookAppointment }) {
  return (
    <section data-testid="final-cta-section" className="py-16 md:py-24 bg-navy relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-teal rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />
      </div>
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-3xl text-center relative">
        <h2 className="reveal font-heading font-bold text-3xl md:text-4xl text-white tracking-tight mb-4">
          Take the First Step Towards Better Health
        </h2>
        <p className="reveal delay-1 text-slate-300 text-base md:text-lg leading-relaxed mb-8 max-w-xl mx-auto">
          Don't let pain hold you back. Schedule a consultation with Dr. Dileep Sunkavalli and explore
          your treatment options with one of Vijayawada's most trusted surgeons.
        </p>
        <div className="reveal delay-2">
          <button
            data-testid="final-cta-book-btn"
            onClick={onBookAppointment}
            className="inline-flex items-center gap-2 text-white font-semibold px-10 py-4 rounded-lg transition-all hover:-translate-y-0.5 text-base"
            style={{
              background: "linear-gradient(135deg, #2E6FB8 0%, #1F4E79 100%)",
              boxShadow: "0 4px 16px rgba(31,78,121,0.4), inset 0 1px 0 rgba(255,255,255,0.15)"
            }}
          >
            <CalendarCheck className="w-5 h-5" strokeWidth={1.5} />
            Book Your Appointment Now
          </button>
        </div>
      </div>
    </section>
  );
}
